import React from "react";

declare const window: any;

const LegalText = ({ isLegalText, text, setIsLegalText, color }: any) => {
  return (
    <div className={`legal-text-container-external  ${isLegalText ? "show" : ""}`}>
      <div className={`legal-text-container`}>
        {text}
        <div className="legal-text-close" style={{backgroundColor: color}} onClick={() => setIsLegalText(false)}>
          <i className="fas fa-xmark"></i>
        </div>
      </div>
    </div>
  );
};

export default LegalText;
